export const SYNTH_PRESETS = {
  engine: { wave: "triangle", from: 80, to: 80, seconds: 1, volume: 0.025, loop: true },
  takeoff: { wave: "sine", from: 220, to: 660, seconds: 0.4, volume: 0.09, loop: false },
  tick: { wave: "sine", from: 880, to: 660, seconds: 0.06, volume: 0.04, loop: false },
  cashout: { wave: "sine", from: 520, to: 1040, seconds: 0.35, volume: 0.1, loop: false },
  crash: { wave: "sawtooth", from: 160, to: 40, seconds: 0.45, volume: 0.07, loop: false },
} as const;
export type AudioCue = keyof typeof SYNTH_PRESETS;
